module.exports = global["Phaser"] = require("-!./phaser-split.js");


//////////////////
// WEBPACK FOOTER
// ./~/phaser-ce/build/custom/phaser-split.js
// module id = 24
// module chunks = 1